import React, { useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import TableTop from "./../../../component/atoms/layout/table/tableTop";
import TableCount from "./../../../component/molecules/tableCount";
import SearchBar from "./../../../component/atoms/input/searchBar";
import ExcelBtn from "./../../../component/atoms/button/excelBtn";
import { route } from "../../../router/route";
import { toastMsg } from "../../../util/toastMsg";
import { errorHandler } from "../../../util/errorHandler";
import RedBtn from "./../../../component/atoms/button/redBtn";
import Modal from "../../../component/templates/Modal";
import Pagination from "./../../../component/molecules/pagination";
import Table from "../../../component/atoms/layout/table/table";
import Tr from "./../../../component/atoms/layout/table/tr";
import Th from "./../../../component/atoms/layout/table/th";
import Checkbox from "./../../../component/atoms/input/checkbox";
import TableText from "./../../../component/atoms/text/table/tableText";
import Td from "./../../../component/atoms/layout/table/td";
import DetailBtn from "./../../../component/atoms/button/detailBtn";
import SelectBox from "../../../component/organisms/selectBox";
import MemberApi from "../../../api/member.api";
import SelectBoxValue from "../../../component/organisms/selectBoxValue";
import Empty from "../../../component/molecules/empty";
import { cMembershipList } from "../../../constants/userInfoConstants";
import moment from "moment";

// sessionStorage 초기화
function sessionStorageInit() {
  sessionStorage.removeItem("sCheckedListStorage");
  const event = new Event("sessionStorageChange");
  window.dispatchEvent(event);
}

const UserWithdraw = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams(); // eslint-disable-line no-unused-vars
  const [isWriteAuthority, setIsWriteAuthority] = useState(false);

  // ---------- 쓰기 권한체크 ---------- //
  useEffect(() => {
    const writeMenu = sessionStorage.getItem("writeMenu");

    if (writeMenu?.includes(route.user_withdraw)) {
      setIsWriteAuthority(true);
    } else {
      setIsWriteAuthority(false);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const [keyword, setKeyword] = useState("");

  const page = useMemo(() => {
    return searchParams.get("page") ? searchParams.get("page") : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 10, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
    first: false,
    last: false,
  });

  // ---------- 행 수 관련 ---------- //
  const [selectedRowsPerPage, setSelectedRowsPerPage] = useState("10");
  const [rowsPerPageListBoxOpen, setRowsPerPageListBoxOpen] = useState(false);
  const rowsPerPageList = [
    {
      title: "10명씩",
      value: "10",
    },
    {
      title: "30명씩",
      value: "30",
    },
    {
      title: "50명씩",
      value: "50",
    },
    {
      title: "100명씩",
      value: "100",
    },
  ];

  const [withdrawList, setWithdrawList] = useState([]);

  useEffect(() => {
    return () => {
      sessionStorage.removeItem("sCheckedListStorage");
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    setKeyword(searchParams.get("keyword") ? searchParams.get("keyword") : "");
    setSelectedRowsPerPage(
      searchParams.get("perPage") ? searchParams.get("perPage") : "10"
    );

    getMemberList();
  }, [location]); // eslint-disable-line react-hooks/exhaustive-deps

  const getMemberList = async () => {
    try {
      const data = {
        page: Number(page),
        size: searchParams.get("perPage")
          ? Number(searchParams.get("perPage"))
          : pagination.size,
        membershipFlag: "Active",
      };

      if (searchParams.get("keyword")) {
        data.keyword = searchParams.get("keyword");
      }

      const response = (await MemberApi.retiredMemberList(data)).data.data;

      const processedResponse = [...response.content].map((item) => {
        if (item.age === null) {
          item.age = "-";
        } else {
          const year = item.age.split("-")[0];
          const currentYear = new Date().getFullYear();
          const koreanAge = currentYear - year + 1;

          if (koreanAge < 10) {
            item.age = "10대 미만";
          } else if (koreanAge < 20) {
            item.age = "10대";
          } else if (koreanAge < 30) {
            item.age = "20대";
          } else if (koreanAge < 40) {
            item.age = "30대";
          } else if (koreanAge < 50) {
            item.age = "40대";
          } else if (koreanAge < 60) {
            item.age = "50대";
          } else if (koreanAge >= 60) {
            item.age = "60대 이상";
          }
        }

        return {
          ...item,
          checked: false,
        };
      });

      setWithdrawList(processedResponse);
      setPagination({
        ...pagination,
        totalCount: response.totalCount,
        totalPages: Math.ceil(
          response.totalCount /
            (searchParams.get("perPage")
              ? Number(searchParams.get("perPage"))
              : pagination.size)
        ),
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  // ---------- 삭제 및 체크 관련 ---------- //

  const sessionStorageCheckedList = sessionStorage.getItem(
    "sCheckedListStorage"
  );
  const [checkedListStorage, setCheckedListStorage] = useState([]);
  const [buttonGroupOpen, setButtonGroupOpen] = useState(false);
  const [isAllCheck, setIsAllCheck] = useState(false);

  useEffect(() => {
    const handleStorageChange = () => {
      setCheckedListStorage(
        sessionStorageCheckedList ? JSON.parse(sessionStorageCheckedList) : []
      );
    };

    window.addEventListener("sessionStorageChange", handleStorageChange);

    return () => {
      window.removeEventListener("sessionStorageChange", handleStorageChange);
    };
  }, []); // eslint-disable-line

  useEffect(() => {
    sessionStorage.setItem(
      "sCheckedListStorage",
      JSON.stringify(checkedListStorage)
    );
  }, [page]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (withdrawList.length > 0) {
      const idsInArray1 = new Set(checkedListStorage.map((item) => item.id));

      const allIdsIncluded = withdrawList.every((item) =>
        idsInArray1.has(item.id)
      );

      setIsAllCheck(allIdsIncluded);
    }

    if (checkedListStorage.length > 0) {
      setButtonGroupOpen(true);
    } else {
      setButtonGroupOpen(false);
    }
  }, [checkedListStorage, withdrawList]); /// eslint-disable-line react-hooks/exhaustive-deps

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const deleteFunc = async () => {
    try {
      let delIds = checkedListStorage.map((item) => item.id);

      let data = {
        ids: delIds,
        allFlag: false,
      };

      await MemberApi.retiredMemberDel(data);

      sessionStorageInit();
      setDeleteModalOpen(false);
      toast(toastMsg.delete);

      navigate(
        `${route.user_withdraw}?page=1&perPage=${selectedRowsPerPage}&keyword=${keyword}`
      );
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle>탈퇴 회원</TableTitle>
          {/* 테이블 상단 영역 */}
          <TableTop>
            <TableCount text={"탈퇴 회원"} count={pagination.totalCount} />
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
              }}
            >
              <SearchBar
                value={keyword}
                placeholder={"이름, 아이디(이메일), 닉네임"}
                onChange={(e) => {
                  setKeyword(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    sessionStorageInit();
                    navigate(
                      `${route.user_withdraw}?page=1&perPage=${selectedRowsPerPage}&keyword=${keyword}`
                    );
                  }
                }}
                onClick={() => {
                  sessionStorageInit();
                  navigate(
                    `${route.user_withdraw}?page=1&perPage=${selectedRowsPerPage}&keyword=${keyword}`
                  );
                }}
              />
              {/* <ExcelBtn /> */}
              <SelectBoxValue
                isMiddle={true}
                selectedValue={selectedRowsPerPage}
                isOpen={rowsPerPageListBoxOpen}
                wrapperHandler={() => {
                  setRowsPerPageListBoxOpen(!rowsPerPageListBoxOpen);
                }}
                itemList={rowsPerPageList}
                selectedValueSetterFunc={(value) => {
                  sessionStorageInit();
                  navigate(
                    `${route.user_withdraw}?page=1&perPage=${value}&keyword=${keyword}`
                  );
                }}
              />
            </div>
          </TableTop>

          {/* 버튼 그룹 */}
          {buttonGroupOpen && isWriteAuthority && (
            <div
              style={{
                width: "100%",
                height: 49,
                display: "flex",
                gap: 12,
              }}
            >
              <RedBtn
                style={{
                  backgroundColor: "#272829",
                }}
                onClick={() => {
                  setDeleteModalOpen(true);
                }}
              >
                내역 삭제
              </RedBtn>
            </div>
          )}

          {/* 테이블 영역 */}
          <Table>
            <colgroup>
              {/* 합계: 1044px */}
              {/* 체크박스 */}
              <col width="56px" />
              {/* 이름/아이디(이메일) */}
              <col width="224px" />
              {/* 연령/성별 */}
              <col width="116px" />
              {/* 회원등급/레벨 */}
              <col width="181px" />
              {/* 가입일 */}
              <col width="143px" />
              {/* 탈퇴일 */}
              <col width="220px" />
              {/* 보기 */}
              <col width="99px" />
            </colgroup>
            <thead>
              <Tr style={{ height: "41px", background: "#272829" }}>
                <Th style={{ paddingLeft: "20px" }}>
                  <Checkbox
                    checked={isAllCheck}
                    onChange={(e) => {
                      if (e.target.checked) {
                        // 배열 병합 및 중복 제거
                        const mergedArray = [
                          ...withdrawList,
                          ...checkedListStorage,
                        ].reduce((acc, current) => {
                          const existingItem = acc.find(
                            (item) => item.id === current.id
                          );
                          if (!existingItem) {
                            acc.push(current);
                          }
                          return acc;
                        }, []);

                        setCheckedListStorage(mergedArray);
                      } else {
                        const idsToExclude = new Set(
                          withdrawList.map((item) => item.id)
                        );
                        const filteredArray = checkedListStorage.filter(
                          (item) => !idsToExclude.has(item.id)
                        );

                        setCheckedListStorage(filteredArray);
                      }
                    }}
                  />
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    이름/아이디(이메일)
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    연령/성별
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    회원등급/레벨
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    가입일
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    탈퇴일
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    보기
                  </TableText>
                </Th>
              </Tr>
            </thead>
            <tbody>
              {withdrawList.map((item, index) => {
                return (
                  <Tr
                    key={index}
                    style={{
                      height: "76px",
                      padding: "20px 0px",
                      background: "transparent",
                      borderBottom: "0.5px solid rgba(255, 255, 255, 0.12)",
                    }}
                  >
                    <Td style={{ paddingLeft: "20px" }}>
                      <Checkbox
                        checked={checkedListStorage.some(
                          (item02) => item02.id === item.id
                        )}
                        onChange={() => {
                          if (
                            checkedListStorage.length > 0 &&
                            checkedListStorage.some(
                              (item02) => item02.id === item.id
                            )
                          ) {
                            let temp = checkedListStorage.filter(
                              (item02) => item02.id !== item.id
                            );
                            setCheckedListStorage(temp);
                          } else {
                            setCheckedListStorage([
                              item,
                              ...checkedListStorage,
                            ]);
                          }
                        }}
                      />
                    </Td>
                    <Td>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <TableText
                          style={{
                            maxWidth: 166,
                          }}
                        >
                          {item.name}
                        </TableText>
                        <TableText
                          style={{
                            maxWidth: 166,
                          }}
                        >
                          {item.email}
                        </TableText>
                      </div>
                    </Td>
                    <Td>
                      <TableText>
                        {item.age}/{item.gender === "male" ? "남" : "여"}
                      </TableText>
                    </Td>
                    <Td>
                      <TableText>
                        {cMembershipList[item.membership]}/Lv.
                        {item.writingLevel}
                      </TableText>
                    </Td>
                    <Td>
                      <TableText>
                        {moment(item.joinDate).format("YYYY-MM-DD")}
                      </TableText>
                    </Td>
                    <Td>
                      <TableText>
                        {moment(item.createdAt).format("YYYY-MM-DD")}
                      </TableText>
                    </Td>
                    <Td>
                      <DetailBtn
                        onClick={() => {
                          navigate(`${route.user_withdraw_detail}/${item.id}`);
                        }}
                      />
                    </Td>
                  </Tr>
                );
              })}
            </tbody>
          </Table>
          {withdrawList.length > 0 ? null : <Empty />}

          {/* 페이지네이션 영역 */}
          <Pagination
            route={route.user_withdraw}
            queryString={`perPage=${selectedRowsPerPage}&keyword=${keyword}`}
            currentPage={page}
            totalPages={pagination.totalPages}
            rangeSize={pagination.rangeSize}
            first={pagination.first}
            last={pagination.last}
          />
        </DetailPageLayout>
      </MainLayout>

      {/* 삭제 모달 */}
      {deleteModalOpen && (
        <Modal
          type="negative"
          title="삭제하시겠습니까?"
          text={
            <>
              삭제된 데이터는 복구가 불가합니다.
              <br />
              그래도 삭제하시겠습니까?
            </>
          }
          setModalOpen={setDeleteModalOpen}
          onClick={deleteFunc}
        />
      )}
    </>
  );
};

export default UserWithdraw;
